import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentPlatform } from 'src/app/data/store/selectors/platform.selectors';
import {
  emailImgSrc,
  locationImgSrc,
  phoneNumberImgSrc,
  wordDeclensions,
} from 'src/app/shared/constants';
import { CurrentPlatform, TextSizes, TextType } from 'src/app/shared/enums';
import { IBillboardInfoData } from 'src/app/shared/interfaces';
import { copyOnLongPress } from 'src/app/shared/utils/gestures/longPress';
import { AsyncPipe } from '@angular/common';
import { TextComponent } from '../../text/text.component';
import { ImageComponent } from '../../image/image.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { WordDeclensionPipe } from '../../../pipe/word-declension/word-declension.pipe';
import { PhoneNumberPipe } from '../../../pipe/phone-number/phone-number.pipe';
@Component({
  selector: 'app-information-card',
  templateUrl: './information-card.component.html',
  styleUrls: ['./information-card.component.scss'],
  imports: [
    TextComponent,
    ImageComponent,
    SvgIconComponent,
    AsyncPipe,
    WordDeclensionPipe,
    PhoneNumberPipe,
  ],
})
export class InformationCardComponent implements OnDestroy, AfterViewInit {
  private _store = inject(Store);

  @Input() info?: IBillboardInfoData;

  @ViewChild('email') email?: ElementRef<HTMLDivElement>;

  @ViewChild('phone') phone?: ElementRef<HTMLDivElement>;

  @ViewChild('location') location?: ElementRef<HTMLDivElement>;

  @ViewChild('description') description?: ElementRef<HTMLDivElement>;

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  readonly currentPlatform = CurrentPlatform;

  readonly employeesDeclension = wordDeclensions.employees;

  readonly emailImgSrc = emailImgSrc;

  readonly locationImgSrc = locationImgSrc;

  readonly phoneNumberImgSrc = phoneNumberImgSrc;

  readonly platform$ = this._store.select(selectCurrentPlatform);

  private emailCopyUnsubscribe: VoidFunction = () => {
    // no-op: обработка по умолчанию
  };

  private phoneCopyUnsubscribe: VoidFunction = () => {
    // no-op: обработка по умолчанию
  };

  private locationCopyUnsubscribe: VoidFunction = () => {
    // no-op: обработка по умолчанию
  };

  private descriptionCopyUnsubscribe: VoidFunction = () => {
    // no-op: обработка по умолчанию
  };

  ngAfterViewInit(): void {
    if (this.email && this.info?.description.email) {
      this.emailCopyUnsubscribe = copyOnLongPress(
        this.email.nativeElement,
        this.info.description.email,
      );
    }
    if (this.phone && this.info?.description.phone) {
      this.phoneCopyUnsubscribe = copyOnLongPress(
        this.phone.nativeElement,
        this.info.description.phone,
      );
    }
    if (this.location && this.info?.description.city?.name && this.info.description.house) {
      this.locationCopyUnsubscribe = copyOnLongPress(
        this.location.nativeElement,
        [this.info.description.city.name, this.info.description.house].join(' '),
      );
    }
    if (this.description && this.info?.description.description) {
      this.descriptionCopyUnsubscribe = copyOnLongPress(
        this.description.nativeElement,
        this.info.description.description,
      );
    }
  }

  ngOnDestroy(): void {
    this.emailCopyUnsubscribe();
    this.phoneCopyUnsubscribe();
    this.locationCopyUnsubscribe();
    this.descriptionCopyUnsubscribe();
  }
}
